import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table, { ColumnDefinitionType } from "../../../../../components/Table";
import { Loading } from "../../../../../components/Loading";
import Confirm from "../../../../../components/Confirm";
import FormSelectBox from "../../../../../components/Form/FormSelectBox";
import { cargarCombo } from "../../../../../services/Service";
import { TrabajoEmpresa } from "../../../../../types/TrabajoEmpresa";
import { toast } from "react-toastify";

type TiposTrabajoProps = {
    tiposTrabajo: TrabajoEmpresa[],
    setTiposTrabajo: (value: TrabajoEmpresa[]) => void,
    idEmpresaGestora: number,
    nombreEmpresa: string,
    edit: boolean,
    view: boolean,
    loading?: boolean,
}

const SeccionTiposTrabajo = ({ edit, view, tiposTrabajo, setTiposTrabajo, idEmpresaGestora, nombreEmpresa, loading = false }: TiposTrabajoProps) => {
    const [tiposTrabajoCatalogo, setTiposTrabajoCatalogo] = useState<any[]>([]);
    const [tiposTrabajoDisponibles, setTiposTrabajoDisponibles] = useState<any[]>([]);
    const [idTipoTrabajoSeleccionado, setIdTipoTrabajoSeleccionado] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const toggle = () => setShowModal(!showModal);
    const [data, setData] = useState<TrabajoEmpresa | null>(null);

    useEffect(() => {
        cargarCombo('tiposTrabajos', setTiposTrabajoCatalogo);
    }, [])

    useEffect(() => {
        const disponibles = (tiposTrabajoCatalogo || []).filter(
            (tt: any) => !tiposTrabajo.some(asociado => asociado.idTipoTrabajo === tt.id)
        );
        setTiposTrabajoDisponibles(disponibles);
    }, [tiposTrabajoCatalogo, tiposTrabajo])

    const getDescripcion = (idTipoTrabajo: number) => {
        const tipoTrabajo = tiposTrabajoCatalogo.find((tt: any) => tt.id === idTipoTrabajo);
        return tipoTrabajo ? tipoTrabajo.descripcion : '';
    }

    const eliminar = () => {
        if (data) {
            const restantes = tiposTrabajo.filter(tt => tt.idTipoTrabajo !== data.idTipoTrabajo);
            setTiposTrabajo(restantes);
        }
        toggle();
    }

    const agregar = () => {
        if (!idTipoTrabajoSeleccionado) {
            toast.error('Debe seleccionar un Tipo de Trabajo');
            return;
        }
        const yaAsociado = tiposTrabajo.some(tt => tt.idTipoTrabajo === Number(idTipoTrabajoSeleccionado));
        if (yaAsociado) {
            toast.error('El Tipo de Trabajo ya se encuentra asociado');
            return;
        }
        const tipoTrabajoCatalogo = tiposTrabajoCatalogo.find((tt: any) => tt.id === Number(idTipoTrabajoSeleccionado));
        if (tipoTrabajoCatalogo) {
            const nuevoTrabajoEmpresa: TrabajoEmpresa = {
                id: 0,
                idEmpresaGestora: idEmpresaGestora,
                idTipoTrabajo: tipoTrabajoCatalogo.id,
                tipoTrabajo: tipoTrabajoCatalogo.nombre,
                empresaGestora: nombreEmpresa,
            }
            setTiposTrabajo([...tiposTrabajo, nuevoTrabajoEmpresa]);
            setIdTipoTrabajoSeleccionado('');
        }
    }

    const columns: ColumnDefinitionType<TrabajoEmpresa, keyof TrabajoEmpresa>[] = []
    columns.push({
        key: 'tipoTrabajo',
        header: 'Nombre del Trabajo',
    });
    columns.push({
        key: 'idTipoTrabajo',
        header: 'Descripción',
        cell: (data: TrabajoEmpresa) => <>{getDescripcion(data.idTipoTrabajo)}</>
    });
    if (!view) {
        columns.push({
            key: 'id',
            header: 'Acciones',
            cell: (data: TrabajoEmpresa) =>
                <>
                    <Link to="#" title="eliminar"
                        onClick={(e) => {
                            e.stopPropagation();
                            setData(data);
                            setShowModal(true);
                        }}
                    >
                        <i className="fa fa-trash-o mr-2 text-danger" aria-hidden="true"></i>
                    </Link>
                </>
        });
    }

    return (
        <>
            <Confirm isOpen={showModal} toggle={toggle} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        {<p>Está seguro que desea eliminar el Tipo de Trabajo {data?.tipoTrabajo}?</p>}
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        {!view &&
                            <div className="row mt-2 mb-3 justify-content-center">
                                <FormSelectBox
                                    title={'Tipo de Trabajo'}
                                    label={'Tipo de Trabajo'}
                                    id={'idTipoTrabajo'}
                                    name={'idTipoTrabajo'}
                                    onChange={(e) => setIdTipoTrabajoSeleccionado(e.target.value)}
                                    optionId={'id'}
                                    optionLabel={'nombre'}
                                    value={idTipoTrabajoSeleccionado}
                                    options={tiposTrabajoDisponibles}
                                    isDisabled={edit && view}
                                />
                            </div>
                        }

                        <h4 className="m-t-0 header-title">
                            Tipos de Trabajo
                            {!view &&
                                <Link to="#" title="Agregar" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        agregar();
                                    }}>
                                    <i className="fa fa-plus margin-right-10"></i> Agregar
                                </Link>
                            }
                        </h4>

                        <div className="table-responsive">
                            <br />
                            {loading ? <Loading /> : <Table data={tiposTrabajo || []} columns={columns}></Table>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SeccionTiposTrabajo;
